var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'p-0',
    _vm.col ? 'col-' + _vm.col : 'col-12',
    'abi-multiselect',
    _vm.selected && (_vm.selected.length > 0 || typeof _vm.selected === 'object')
      ? 'active'
      : '',
  ]},[_c('multiselect',_vm._g({attrs:{"tag-placeholder":"Add this as new tag","placeholder":"","label":"name","track-by":"id","options":_vm.options,"multiple":_vm.multiple,"taggable":_vm.multiple,"disabled":_vm.disabled},on:{"tag":_vm.addTag,"select":_vm.onSelect,"remove":_vm.onRemove},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},_vm.$listeners)),_c('label',{staticClass:"typo__label"},[_vm._v(_vm._s(_vm.label)),(_vm.required)?_c('span',{staticClass:"text-danger"},[_vm._v("*")]):_vm._e()]),((_vm.errors && !!_vm.errors[_vm.name]) || _vm.information)?_c('p',{class:[
      'message',
      _vm.errors && !!_vm.errors[_vm.name] && 'error',
      !_vm.errors[_vm.name] && _vm.information && 'infromation',
    ],attrs:{"title":_vm.errors[_vm.name] || _vm.information}},[_vm._v(" "+_vm._s(_vm.errors && _vm.errors[_vm.name] ? _vm.errors[_vm.name] : _vm.information && _vm.information)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }